import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';

export const coreDateTimePickerStyles: SxProps<Theme> = {
	'&.MuiPickersLayout-root': {
		backgroundColor: Colors.black_a20,
		backdropFilter: 'blur(20px)',
		transitionDuration: '0.5s',
		transitionProperty: 'all',
	},

	'& .MuiPickersToolbar-root': {
		backgroundColor: Colors.transparent,

		'& .MuiTypography-overline': {
			display: 'none',
		},

		'& .MuiTypography-root': {
			color: Colors.white,
			fontFamily: 'Integral CF, sans-serif',
		},

		'& .MuiDateTimePickerToolbar-dateContainer': {

			"& .MuiTypography-subtitle1": {
				fontSize: '16px',
				fontWeight: 500,
				lineHeight: '19px',
			},

			"& .MuiTypography-h4": {
				fontSize: '28px',
				fontWeight: 700,
				lineHeight: '34px',
			},
		},

		'& .MuiDateTimePickerToolbar-timeContainer': {
			height: '100%',

			'& .MuiTypography-root': {
				opacity: 0.45,

				"&.Mui-selected": {
					opacity: 1
				}
			},

			'& .MuiDateTimePickerToolbar-timeDigitsContainer': {
				alignItems: 'flex-end',

				'& .MuiTypography-root': {
					fontSize: '28px',
					fontWeight: 700,
					lineHeight: '34px',
				},

				'& .MuiDateTimePickerToolbar-separator': {
					mx: '2px',
				}
			},

			'& .MuiDateTimePickerToolbar-ampmSelection': {
				justifyContent: 'space-between',
				mb: '4px',

				'& .MuiTypography-root': {
					fontSize: '16px',
					fontWeight: 500,
					lineHeight: '19px',
				}
			}
		}
	},

	'& .MuiTabs-root': {
		backgroundColor: Colors['070605'],

		'& .MuiTab-root': {
			color: Colors.white,

			"& >svg": {
				opacity: 0.45,
				fontSize: '22px',
			},

			"&.Mui-selected": {
				color: Colors.white,

				"& >svg": {
					opacity: 1
				},

			}
		},

		'& .MuiTabs-indicator': {
			height: '3px',
			backgroundColor: Colors.white,
		},
	},

	'& .MuiTimeClock-root': {
		backgroundColor: Colors['070605'],

		'& .MuiPickersArrowSwitcher-root': {
			display: 'none',
		}
	},

	'& .MuiPickersFadeTransitionGroup-root': {
		'& .MuiPickersYear-yearButton.Mui-selected': {
			backgroundColor: Colors.white,
		},
	},

	'& .MuiDateCalendar-root': {
		backgroundColor: Colors.black_a70,

		"& .MuiPickersCalendarHeader-root": {
			p: '0 32px 0 20px',

			'& .MuiPickersCalendarHeader-labelContainer': {
				'& .MuiPickersCalendarHeader-label': {
					fontFamily: 'Montserrat, sans-serif',
					fontSize: '15px',
					fontWeight: 500,
					lineHeight: '18px',
					color: Colors.white_a80,
					mr: '2px',
				},

				'& .MuiButtonBase-root': {
					p: 0,
				}
			},

			"& .MuiPickersArrowSwitcher-root": {
				'& .MuiPickersArrowSwitcher-spacer': {
					width: '50px',
				},

				'& .MuiButtonBase-root': {
					width: '24px',
					height: '24px',
					p: 0,
					fontSize: '20px',
				}
			}
		},

		'& .MuiDayCalendar-header': {
			'& .MuiDayCalendar-weekDayLabel': {
				fontFamily: 'Roboto, sans-serif',
				fontSize: '12px',
				lineHeight: '16px',
				fontWeight: '400',
				color: Colors.white_a80,
			},
		},

		'& .MuiPickersDay-root': {
			fontFamily: 'Roboto, sans-serif',
			color: Colors.white_a87,
			fontSize: '16px',
			lineHeight: '24px',
			fontWeight: 400,
			width: '36px',
			height: '36px',

			"&.Mui-selected": {
				backgroundColor: Colors.white,
				color: Colors.black,
			},

			'&.Mui-disabled:not(.Mui-selected)': {
				color: Colors['969696'],
			},
		}
	},

	'& .MuiClock-root': {
		m: '40px 20px',

		'& .MuiClock-pin': {
			backgroundColor: Colors.white,
		},

		'& .MuiClockPointer-root': {
			backgroundColor: Colors.white,

			'& .MuiClockPointer-thumb': {
				backgroundColor: Colors.white,
				borderColor: Colors.white,
			}
		}
	},
};
